import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "10", cy: "7", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "4", cy: "20", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4.7 19.3 19 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21 3-3 1 2 2Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9.26 7.68 5 12l2 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m10 14 5 2 3.5-3.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m18 12 1-1 1 1-1 1Z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Usb";
const Usb = memo(themed(Icon));
export {
  Usb
};
//# sourceMappingURL=usb.js.map
